import { Dispatch } from "redux";
import { FormItemTypes, SET_FORM_ITEM } from "types/actions/FormItem.actions";

export const setFormItem = (formItem: any) => {
  return (dispatch: Dispatch<FormItemTypes>) => {
    dispatch({ type: SET_FORM_ITEM, formItem: formItem });
  };
};
